<div class="display-profile d-flex align-items-center  justify-content-center">
    <div class="display-profile-image">
        <img src="{{userProfile.picture}}">
    </div>
    <div class="display-profile-description">
        <span class="display-profile-firstname">{{userProfile.firstName}}</span>
        <span class="display-profile-login">({{userProfile.login}})</span>
    </div>
</div>